var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7f7d83",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.033 6.867H2.967m9.116 3.125H7.917m9.166-2.707v8.436a1.77 1.77 0 0 1-1.77 1.77H4.688a1.77 1.77 0 0 1-1.771-1.77V7.285c0-.275.064-.546.187-.792L4.32 4.059c.225-.45.685-.734 1.188-.734h8.984c.503 0 .963.284 1.188.734l1.216 2.434c.123.246.187.517.187.792Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIconGrey);
export default __webpack_public_path__ + "static/media/box-icon-grey.4cc6d1dc13413d57b5ce2f5b7844e290.svg";
export { ForwardRef as ReactComponent };